import { Airline } from "../../../integrated-client/models/";
import { AirlineUI } from "../../../layout/ModalWindows/ModalWindowWrappers/SubRuleBusinessDataModalWrapper";

export type AirlinesList = Array<Airline>;

export class ResultsData {
  items: AirlinesList;
  showMore: boolean;
  total?: number;
  allItems: Array<AirlineUI>;

  constructor() {
    this.items = [];
    this.showMore = false;
    this.allItems = [];
  }
}
